// extracted by mini-css-extract-plugin
export default {"demoBadge":"Demo_demoBadge__zvsgy","demoLogoContainer":"Demo_demoLogoContainer__cWBmH"};